export enum DeptType {
  Board = "Board",
  Division = "Division",
  Department = "Department",
  Team = "Team",
  Branch = "Branch",
  Location = "Location",
}

export const DeptTypeOptions = [
  { value: DeptType.Board, label: "Board" },
  { value: DeptType.Division, label: "Division" },
  { value: DeptType.Department, label: "Department" },
  { value: DeptType.Team, label: "Team" },
  { value: DeptType.Branch, label: "Branch" },
  { value: DeptType.Location, label: "Location" },
];

export enum EmployeeRole {
  Head = "Head",
  SubHead = "SubHead",
  Assistant = "Assistant",
  SubAssistant = "SubAssistant",
  TeamLeader = "TeamLeader",
  SubTeamLeader = "SubTeamLeader",
  Secretary = "Secretary",
}

export const EmployeeRoleOptions = [
  { value: EmployeeRole.Head, label: "Head" },
  { value: EmployeeRole.SubHead, label: "SubHead" },
  { value: EmployeeRole.Assistant, label: "Assistant" },
  { value: EmployeeRole.SubAssistant, label: "SubAssistant" },
  { value: EmployeeRole.TeamLeader, label: "TeamLeader" },
  { value: EmployeeRole.SubTeamLeader, label: "SubTeamLeader" },
  { value: EmployeeRole.Secretary, label: "Secretary" },
];
